export default "__VITE_ASSET__ExZXXuLF__"